<script>

export default {
  name: 'TermsOfServicesForPickupAtConvenientStore'
}
</script>

<template lang="pug" src="./TermsOfServicesForPickupAtConvenientStore.pug"></template>
